import { serverUri } from 'src/config'
import Model, { ID, IsoDateTime, JsonArray, MODEL_LEVEL } from 'src/models/model'
import User from 'src/models/user/User'

export const EXPORTABLE_MODEL_NAMES = ['order_item', 'payment', 'gift_card', 'voucher', 'customerio_export', 'user', 'user_point', 'shortened_url', 'customerio_segment_task_action']

export default class ModelExport extends Model {
  static name = 'ModelExport'

  static level = MODEL_LEVEL.SITE

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Data]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      modelTypeName: {
        type: String,
        default: null
      },
      dataUrlDownloadLink: {
        type: String,
        output: true
      },
      user: {
        type: User,
        reference: true,
        output: true
      },
      parameters: {
        type: JsonArray,
        default: () => ([
        ])
      },
      availableColumnsToExport: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      },
      defaultColumnsToExport: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      },
      availableExportParameters: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      },
      columnsToExport: {
        type: JsonArray,
        default: () => ([])
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      }
    }
    this.queries = {
      getModelParams: {
        arguments: {
          modelTypeName: {
            type: String,
            required: true
          }
        },
        results: {
          user: ModelExport
        }
      }
    }

    this.computed = {
      downloadLink () {
        return { name: 'Download CSV', inProgress: !this.dataUrlDownloadLink, link: serverUri + this.dataUrlDownloadLink }
      }
    }
  }
}
